import React from 'react'

import { useAuthContext } from '../../../hooks/useAuthentication'
import { useBaseInputContext } from '../../../hooks/useBaseInput'

import './Signup.scss'

export const Signup = () => {
  const { requestSignup, signupErrorMessage } = useAuthContext()
  const { mail, setMail, pass, setPass } = useBaseInputContext()
  const request = () => requestSignup(mail, pass)
  const keyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') request()
  }
  return (
    <div className="signup">
      <div className="input">
        <label>メールアドレス</label>
        <input type="text" onChange={(e) => setMail(e.target.value)} value={mail} onKeyPress={(e) => keyPress(e)} />
      </div>
      <div className="input">
        <label>パスワード</label>
        <input type="password" onChange={(e) => setPass(e.target.value)} value={pass} onKeyPress={(e) => keyPress(e)} />
      </div>
      {signupErrorMessage && <div className="error">{signupErrorMessage}</div>}
      <button onClick={request}>新規登録</button>
    </div>
  )
}
